import {
  haveFilterQuery,
  paginator,
  haveSort,
  dateRange,
} from '../../common/auxFun'

const endpointConsumption = {
  LOAD_CONSUMPTION: ({ filter, sort, limit, skip }) =>
    `/v1/alvic/consumption${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_OWN_STATION_CONSUMPTION: ({
    id,
    initDate,
    finishDate,
    filter,
    sort,
    limit,
    skip,
  }) =>
    `/v1/alvic/consumption/ownStation/${id}${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}${dateRange(initDate, finishDate)}`,
  LOAD_PREDICTION: ({ filter, sort, limit, skip }) =>
    `/v1/alvic/consumption/prediction${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_OWN_STATION_PREDICTION: ({
    id,
    initDate,
    finishDate,
    filter,
    sort,
    limit,
    skip,
  }) =>
    `/v1/alvic/consumption/ownStation/${id}/prediction${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}${dateRange(initDate, finishDate)}`,
}

export default endpointConsumption
